export const ACCOUNT_TYPES = {
  asset: 'أصول', liability: 'التزامات', equity: 'حقوق الملكية', revenue: 'إيرادات', expense: 'مصروفات',
};

export function chartMoney(value) {
  if (typeof value !== 'string' || !/^-?\d+\.\d{2}$/.test(value)) return 'غير متاح';
  const [whole, fraction] = value.replace(/^-/, '').split('.');
  const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return `${value.startsWith('-') ? '−' : ''}${grouped}.${fraction} ر.س`;
}

export function chartQuery(period = {}) {
  const params = new URLSearchParams();
  if (period.from) params.set('date_from', period.from);
  if (period.to) params.set('date_to', period.to);
  return params;
}

export function chartCsv(accounts, period) {
  const safe = value => {
    let text = String(value ?? '');
    if (/^[\s]*[=+@-]/.test(text)) text = "'" + text;
    return `"${text.replace(/"/g, '""')}"`;
  };
  const rows = [['الرمز','الحساب','التصنيف','رمز الأب','الرصيد شامل الفروع','الرصيد المباشر','بداية الفترة','نهاية الفترة'],
    ...accounts.map(a => [a.code,a.name_ar,ACCOUNT_TYPES[a.account_type],accounts.find(p=>p.id===a.parent_id)?.code || '',a.balance,a.direct_balance,period.from || 'من البداية',period.to])];
  return '\uFEFF' + rows.map(row=>row.map(safe).join(',')).join('\r\n');
}

export function chartRows(accounts, query = '', type = 'all', expanded = new Set()) {
  const byId = new Map(accounts.map(account => [account.id, account]));
  const children = new Map();
  accounts.forEach(account => {
    const parent = account.parent_id || null;
    if (!children.has(parent)) children.set(parent, []);
    children.get(parent).push(account);
  });
  children.forEach(list => list.sort((a, b) => a.code.localeCompare(b.code, 'en', { numeric: true })));
  const term = query.trim().toLocaleLowerCase();
  const filtering = Boolean(term) || type !== 'all';
  const visible = new Set();
  if (filtering) accounts.forEach(account => {
    if ((type === 'all' || account.account_type === type) &&
        (!term || `${account.code} ${account.name_ar}`.toLocaleLowerCase().includes(term))) {
      let node = account;
      const visited = new Set();
      while (node && !visited.has(node.id)) {
        visited.add(node.id); visible.add(node.id); node = byId.get(node.parent_id);
      }
    }
  });
  const result = [];
  const visited = new Set();
  const walk = (parent, depth) => {
    (children.get(parent) || []).forEach(account => {
      if (visited.has(account.id) || (filtering && !visible.has(account.id))) return;
      visited.add(account.id);
      const count = (children.get(account.id) || []).length;
      result.push({ ...account, depth, childCount: count, expanded: filtering || expanded.has(account.id) });
      if (filtering || expanded.has(account.id)) walk(account.id, depth + 1);
    });
  };
  walk(null, 0);
  return result;
}
